import api from '../utils/axios';

// Tax on an annual income, from the tax slabs HR maintains on the server, for the tax year
// that began in July of fiscalStartYear (see utils/fiscalYear). A failure throws rather than
// falling back to a table kept here: one that disagrees with the slabs would tax the sheet
// from a different source, silently, and it would be saved that way.
export async function calculateTaxFromDatabase(annualIncome, fiscalStartYear) {
  const response = await api.post('/api/tax-slabs/calculate', { income: annualIncome, year: fiscalStartYear });
  if (!response.data.success) {
    throw new Error(response.data.message || 'Tax calculation failed');
  }
  const annualTax = response.data.data.taxAmount;
  return { annualTax, monthlyTax: Math.round(annualTax / 12) };
}
